import { WithTranslation } from 'next-i18next';
import React from 'react';
import { withTranslation } from 'next-i18next';
import { MessageSquare } from 'lucide-react';
import TimeMenu from '../../../dropdowns/TimeMenu';
import UserMenuForTutor from '../../../dropdowns/UserMenuForTutor';
import { Badge } from '@lb-classroom/ui';
import Link from 'next/link';

const DefaultAvatar = '/static/images/default_avatar_orange.png';

interface Props extends WithTranslation {
  t: any;
  user: any;
  numUnseenMessages: number;
  currentLocale: string;
  authActions: any;
  userActions: any;
}

const TutorHeaderDesktopRightPart: React.FC<Props> = ({
  user,
  currentLocale,
  authActions,
  numUnseenMessages,
}: Props) => {
  const name = user.first_name;
  let avatarUrl = DefaultAvatar;
  if (user.thumb_avatar_url) {
    avatarUrl = user.thumb_avatar_url
      .replace('lingualbox-dev', 'lingualbox')
      .replace('lingualbox-staging-sg', 'lingualbox');
  }
  const timezone = user.js_time_zone;
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8 md:items-center">
      <TimeMenu timezone={timezone} currentLocale={currentLocale} />
      <Link href="/messages" className="text-default link-reset relative">
        <MessageSquare className="h-7 w-7 text-secondary" />
        {numUnseenMessages > 0 && (
          <Badge
            variant="destructive"
            className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
          >
            {numUnseenMessages > 99 ? '99+' : numUnseenMessages}
          </Badge>
        )}
      </Link>
      <UserMenuForTutor
        name={name}
        avatarUrl={avatarUrl}
        handleLogout={authActions.logout}
      />
    </div>
  );
};

const wrapped = withTranslation('common')(TutorHeaderDesktopRightPart);

export default wrapped;
